import { shapePersonalizationQuestionsForApp } from '@/utils/product/shapeAttributes';
import { editPersonalization } from '@/utils/edit/personalization';
import { replaceOperation } from '@/utils/product/operations';

import { ENABLED, OPERATIONS, REQUIRED, VALUE } from '@/constants/product';
import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';
import { ETSY } from '@/constants/channels';
import { FORM } from '@/constants/forms';

export function personalization({ operation, product, ...rest }) {
  const operationType = operation.get('type');

  switch (operationType) {
    case OPERATIONS[ETSY].PERSONALIZATION.CHAR_COUNT_MAX_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const { userFeatures } = rest;
      const value = operation.get('value');
      const updates = editPersonalization({ product, userFeatures, [ATTRIBUTE.CHAR_COUNT_MAX]: value });
      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const { userFeatures } = rest;
      const value = operation.get('value');
      const updates = editPersonalization({ product, userFeatures, [ATTRIBUTE.INSTRUCTIONS]: value });
      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.IS_PERSONALIZABLE_SET: {
      const { userFeatures } = rest;
      const value = operation.get('value');
      const updates = editPersonalization({ product, userFeatures, [ENABLED]: value });
      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.IS_REQUIRED_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const { userFeatures } = rest;
      const value = operation.get('value');
      const updates = editPersonalization({ product, userFeatures, [REQUIRED]: value });
      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION_QUESTIONS: {
      const { userFeatures } = rest;
      const value = operation.get('value');
      const updates = editPersonalization({
        product,
        userFeatures,
        [VALUE]: shapePersonalizationQuestionsForApp({ questions: value }),
      });

      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    default: {
      return { product, ...rest };
    }
  }
}
